/**
 * Storage Constants
 *
 * Centralized constants for storage operations including
 * thumbnail sizes and other shared configuration.
 */

/**
 * Thumbnail size configuration
 */
export interface ThumbnailSize {
  width: number;
  height: number;
  quality?: number;
}

/**
 * Preset thumbnail sizes for image transforms
 *
 * @example
 * ```typescript
 * import { ThumbnailSizes } from '@kit/shared/storage';
 *
 * // Use in signed URL generation
 * const result = await service.getSignedUrl(bucket, path, {
 *   transform: ThumbnailSizes.MEDIUM
 * });
 * ```
 */
export const ThumbnailSizes = {
  /** 100x100 - For list items, small previews */
  SMALL: { width: 100, height: 100, quality: 80 } as ThumbnailSize,
  /** 200x200 - For grid displays, cards */
  MEDIUM: { width: 200, height: 200, quality: 80 } as ThumbnailSize,
  /** 400x400 - For larger previews */
  LARGE: { width: 400, height: 400, quality: 85 } as ThumbnailSize,
  /** 800x800 - For full-size previews, dialogs */
  XLARGE: { width: 800, height: 800, quality: 90 } as ThumbnailSize,
} as const;

export type ThumbnailSizeKey = keyof typeof ThumbnailSizes;
